export const PRIMARY_COLOR: string = '#006F46';
export const GREEN: string = '#28A951';
export const RED: string = '#D40001';
export const YELLOW: string = '#FEA705';
export const GREY: string = '#E8E8E8';
export const WHITE: string = '#FFFFFF';
export const CRIMSON_RED: string = '#FF4D4F';

// Banner Colors
export const WARNING_BANNER_BG: string = '#fffbe6';
export const WARNING_BANNER_BORDER: string = '#ffe58f';